module.exports = __webpack_public_path__ + "img/Social-channels.8cf54d58.png";